import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface CommentNotification {
  content: string;
  reportNumber: string;
  referenceID: string;
  updatedAt: string;
}

export interface WorkflowNotification {
  id: number;
  template: number;
  name: string;
  control_id: string;
  status: number;
  priority: number;
  extra_text: string;
  report_reference_id: string;
}

export interface PiiRemovalRequestNotification {
  requestId: number;
  removeCountry: boolean;
  removeDescription: boolean;
  removeFiles: boolean;
  removeFullName: boolean;
  removeMessages: boolean;
}

export interface ReportCaseManagementNotification {
  reportReferenceId: string | null;
  formattedReportNumber: string;
}

export interface ExportJobNotification {
  id: number;
  status: string;
  createdAt: string;
  finishedAt: string;
  jobName: string;
  fileType: string;
  channelId: number;
}

export interface AsyncExportJobNotification {
  id: number;
  exportType: 'report_pdf_export' | 'register_csv_export';
  status: string;
  createdAt: string;
  finishedAt: string;
  fileType: string;
  reportReferenceId: string | null;
  formattedReportNumber: string | null;
  // Register export specific fields
  jobName?: string;
  sourceModelId?: string | number;
}

import { IRFIConversation } from './rfiMessageSlice';
export interface NotificationObject {
  reportNumber?: string;
  id: number | null;
  content: string;
  datetime: string;
  meetingDate: string;
  reportType: string;
  callType: string;
  country: string;
  isRead: boolean;
  meetingId?: number;
  notificationType: string;
  comment: CommentNotification | null;
  messageContent?: string;
  reportReferenceId?: string;
  rfiConversation?: IRFIConversation;
  piiRemovalRequest?: PiiRemovalRequestNotification | null;
  workflowNotification?: WorkflowNotification | null;
  reportCaseManagement?: ReportCaseManagementNotification | null;
  exportJob?: ExportJobNotification | null;
  asyncExportJob?: AsyncExportJobNotification | null;
}

export type NotificationsTabState = {
  notifications: NotificationObject[];
  notificationsBadgeValue: number;
  userType: string;
  userId: number | null;
};

const initialState: NotificationsTabState = {
  notifications: [],
  notificationsBadgeValue: 0,
  userType: '',
  userId: null,
};

const notificationsTabSlice = createSlice({
  name: 'notificationsTab',
  initialState,
  reducers: {
    resetNotifications: () => initialState,
    setNotifications: (state, action: PayloadAction<NotificationObject[]>) => {
      state.notifications = action.payload;
    },
    setNotificationsBadgeNumber: (state, action: PayloadAction<number>) => {
      state.notificationsBadgeValue = action.payload;
    },
    // TODO: review if this is still necessary, and possibly remove it once
    // confirmed since we can get the user type from the auth state
    setUserType: (state, action: PayloadAction<string>) => {
      state.userType = action.payload;
    },
    setUserId: (state, action: PayloadAction<number>) => {
      state.userId = action.payload;
    },
  },
});

export const {
  resetNotifications,
  setUserType,
  setNotifications,
  setNotificationsBadgeNumber,
  setUserId,
} = notificationsTabSlice.actions;

export default notificationsTabSlice.reducer;
